import type { Components } from '@epilot/validation-rules-client'
import { getClient } from '@epilot/validation-rules-client'

import { configureClient, getPublicToken } from '../utils/api-utils'
import { VALIDATION_RULES_API_BASE_URL } from '../utils/config'

/**
 * Keeps a version of the Journey client that uses the Public Journey token to authenticate
 * the underlying requests.
 */
let publicClient: ReturnType<typeof getClient>

export type RuleId = Components.Schemas.ValidationRule['_id']

/**
 * Returns a Journey client that uses the Public Journey token
 *
 * If you wanna make identified requests, prefer {@link getJourneyClient} instead.
 */
export const getPublicValidationRulesClient = () => {
  if (!publicClient) {
    const client = getClient()

    publicClient = configureClient(client, {
      baseURL: VALIDATION_RULES_API_BASE_URL,
      getToken: getPublicToken
    })
  }

  return publicClient
}

export const getValidationRuleById = async (
  id: RuleId | undefined | null,
  signal?: AbortSignal
) => {
  if (!id) throw new Error('Validation Rule id is required')

  const response = await getPublicValidationRulesClient().getValidationRuleById(
    id,
    {
      signal
    }
  )

  return response.data
}
